import type React from 'react';
import { type FC, type MouseEventHandler, useCallback } from 'react';

import classNames from 'classnames';

import type { AriaProps } from '@iconik-io/shared-lib/src/react/a11y/aria';

import styles from './checkbox.module.css';

export type ValueType = boolean | undefined;

export type CheckboxProps = {
  id?: string;
  name?: string;
  value?: ValueType;
  className?: string;
  disabled?: boolean;
  onChange?: (value: ValueType) => void;
  aria?: AriaProps;
  onClick?: MouseEventHandler<HTMLInputElement>;
};

const Checkbox: FC<CheckboxProps> = (props) => {
  const { onChange, id, name, value, disabled, className, aria } = props;

  const handleOnChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>): void => {
      if (disabled) {
        return;
      }
      onChange?.(event.target.checked);
    },
    [disabled, onChange],
  );

  return (
    <div
      className={classNames(className, styles.root, {
        [styles.disabled]: disabled ?? false,
      })}
    >
      <input
        id={id}
        disabled={disabled}
        name={name}
        className={styles.control}
        type="checkbox"
        checked={value}
        onChange={handleOnChange}
        aria-label={aria?.label}
        onClick={props.onClick}
      />
      <div className={styles.slider}>
        <div className={styles.button} />
      </div>
    </div>
  );
};

export default Checkbox;
